

















































































import { Component, Vue } from 'vue-property-decorator';
import { router } from '@/router';
import { mapGetters } from 'vuex';

@Component({})
export default class TemplateListPage extends Vue {
  application = this.$store.state.application;
  dialog = false;
  editedItem = {};
  editedIndex = -1;
  actualPage = 1;
  search = '';
  valid = true;

  get templates(): [] {
    return this.$store.getters['template/getTemplates']();
  }

  get headers() {
    return [
      { text: this.$t('template.code'), value: 'code', width: '20%' },
      { text: this.$t('template.description'), value: 'description', sortable: false, width: '60%' },
      { text: this.$t('general.edit'), value: 'edit', sortable: false, align: 'center' },
      { text: this.$t('general.delete'), value: 'delete', sortable: false, align: 'center' }
    ];
  }

  created(): void {
    this.loadTemplates();
  }

  loadTemplates(): void {
    this.$store.dispatch('template/getAll');
  }

  onPage(page: number): void {
    this.actualPage = page;
  }

  editItem(item: any) {
    this.editedIndex = item.id;
    this.$store.dispatch('template/getById', item.id).then(item => (this.editedItem = item));
    this.dialog = true;
  }

  close() {
    this.dialog = false;
    this.$nextTick(() => {
      this.editedIndex = -1;
      this.editedItem = Object.assign({}, null);
      (this.$refs.form as any).reset();
    });
  }

  deleteItem(item: any) {
    if (confirm('Opravdu si přejete odstranit položku?')) {
      const id = item.id;
      this.$store.dispatch('template/delete', { id });
    }
  }

  save() {
    if (this.editedIndex > -1) {
      const template = this.editedItem;
      const id = (this.editedItem as any).id;
      this.$store.dispatch('template/update', { id, template });
    } else {
      const template = this.editedItem;
      this.$store.dispatch('template/create', { template });
    }
    this.close();
  }
}
